/**
 * Module dependencies.
 */

import { NextSeoProps, generateNextSeo } from 'next-seo/pages';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { absoluteUrlResolve } from 'src/core/utils/url';

/**
 * Constants.
 */

const isProduction = process.env.NEXT_PUBLIC_IS_PRODUCTION === 'true';

/**
 * Export `SEO` component.
 */

export const SEO = (props: NextSeoProps) => {
  const { asPath } = useRouter();
  const { t } = useTranslation();

  return (
    <Head>
      {generateNextSeo({
        canonical: absoluteUrlResolve(asPath.replace(/#.*/, '').replace(/\?.*/, '')),
        nofollow: !isProduction,
        noindex: !isProduction,
        openGraph: {
          description: t('common:metatags.description'),
          images: [{ alt: 'BRP', height: 900, url: absoluteUrlResolve('/images/og-image.jpg'), width: 1600 }],
          title: t('common:metatags.title'),
          type: 'website'
        },
        ...props
      })}
    </Head>
  );
};
